import $ from 'jquery';

export default class FooterLinks {
    init() {
        $(document).ready(() => { this.setup(); });
    }

    setup() {
        let $returnTop = $('#return-to-top');
        let $scrollUp = $('#scroll-up');

        $scrollUp.on('click', function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
            return false;
        });

        $(window).on('scroll', function () {
            if ($(this).scrollTop() >= 50) {
                $returnTop.fadeIn(500);
            } else {
                $returnTop.fadeOut(500);
            }
        });

        $returnTop.on('click', function () {
            $('body, html').animate({scrollTop : 0}, 500);
        });
    }
}